window.theme = window.theme || {};

theme.utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }
}

theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;
  
    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes(',')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
})();

class ProductAddons extends HTMLElement {
  constructor() {
    super();
    this.totalPriceEl = null;
    this.countBubbleEl = null;
  }

  connectedCallback() {
    this.totalPriceEl = this.querySelector('[js-total-price]');
    this.countBubbleEl = this.querySelector('[js-count-bubble]');
    this.clearBtn = this.querySelector('[js-clear-btn]');
    this.formId = this.getAttribute("data-form-id")
    this.attachEvents();
  }

  attachEvents() {
    this.querySelectorAll('[js-checkbox]').forEach((checkbox) => {
      checkbox.addEventListener('change', this.handleAddonsProducts.bind(this));
    });

    this.querySelectorAll('[js-quantity-button]').forEach((button) => {
      button.addEventListener('click', (event) => this.handleQuantityChange(event));
    });

    this.clearBtn.addEventListener("click", this.handleClear.bind(this));
  }

  handleQuantityChange(event) {
    const button = event.currentTarget;
    const container = button.closest('.quantity__selector');
    const input = container.querySelector('[js-quantity-input]');
    let value = parseInt(input.value, 10);

    if (button.dataset.name === 'minus' && value > 1) {
      value--;
    } else if (button.dataset.name === 'plus') {
      value++;
    }

    input.value = value;
    this.updateTotal();
  }

  updateTotal() {
    let total = 0;
    let count = 0;

    this.querySelectorAll('[js-product-card]').forEach((item) => {
      const checkbox = item.querySelector('[js-checkbox]');
      const quantityInput = item.querySelector('[js-quantity-input]');
      const price = parseInt(item.getAttribute("data-price"));

      if (checkbox.checked) {
        const quantity = 1;
        total += quantity * price;
        count += quantity;
      }
    });

    if (this.totalPriceEl) {
      this.totalPriceEl.innerHTML = theme.Currency.formatMoney(total, theme.settings.moneyFormat);
    }

    if (this.countBubbleEl) {
      this.countBubbleEl.textContent = count;
    }
  }

  handleAddonsProducts({ currentTarget }) {
    const productCard = currentTarget.closest("[js-product-card]");
    const variantIdField = productCard.querySelector("[js-variant-id-field]");
    const quantityField = productCard.querySelector("[js-quantity-input]");

    if(currentTarget.checked) {
        variantIdField.setAttribute("form", this.formId);
        // quantityField.setAttribute("form", this.formId);
    }else {
        variantIdField.removeAttribute("form");
        // quantityField.removeAttribute("form");
    }

    if(this.querySelector("[js-checkbox]:checked")) {
        this.clearBtn.classList.remove("hidden");
    }else {
        this.clearBtn.classList.add("hidden");
    }
    this.updateTotal();
  }

  handleClear({ currentTarget }) {
    this.querySelectorAll("[js-checkbox]").forEach(el => el.checked = false);
    this.querySelectorAll("[js-variant-id-field]").forEach(el => el.removeAttribute("form"));
    this.querySelectorAll("[js-quantity-input]").forEach(el => el.removeAttribute("form"));

    if (this.totalPriceEl) {
      this.totalPriceEl.innerHTML = theme.Currency.formatMoney(0, theme.settings.moneyFormat);
    }

    if (this.countBubbleEl) {
      this.countBubbleEl.textContent = 0;
    }

    currentTarget.classList.add("hidden");
  }
}

customElements.define('product-addons', ProductAddons);